import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import * as Constants from "src/core/Constants";
import { environment } from "src/core/Configurations/Environment.config";

const browserHistory = createBrowserHistory();
export const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: environment.REACT_APP_APP_INSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

if (
  !!environment.REACT_APP_ENV &&
  environment.REACT_APP_ENV != Constants.Environments.DEV
) {
  appInsights.loadAppInsights();
}
